module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACoAAAAGCAYAAAC1rQwWAAAAAXNSR0IArs4c6QAAAB9JREFUKBVj/A8EDEMAMA0BN4KdOOpQasfUaIhSO0QB2s0ECI+raTUAAAAASUVORK5CYII="


//////////////////
// WEBPACK FOOTER
// ./src/static/img/icon-minus.png
// module id = 324
// module chunks = 0